import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/CheckBox';

const CompactValue = ({ value }) => (
  <Box width="100%">
    <Typography variant="body2" sx={{ width: '100%' }}>
      {value || '-'}
    </Typography>
  </Box>
);

const YachtCompactPreview = ({
  registry,
  mexalCode,
  mexalValidation,
  noteAttendance,
  salesChannel,
  provenence,
}) => (
  <Paper
    variant="outlined"
    sx={{ p: 1.25, borderRadius: 1.5, bgcolor: 'grey.50', width: '100%' }}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        columnGap: 2,
        rowGap: 1,
      }}
    >
      <CompactValue value={registry} />
      <CompactValue value={mexalCode} />
      <CompactValue value={mexalValidation ? <CheckIcon color='success' /> : <CancelIcon color='error' />} />
      <CompactValue value={noteAttendance} />
      <CompactValue value={salesChannel} />
      <CompactValue value={provenence} />
    </Box>
  </Paper>
);

export default YachtCompactPreview;
